<template>
    <div class="lw-course-contents-chapter mb-6rem" @click="sectionClicked" :class="sectionWrapperClass">
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-stretch">
            <div class="lw-course-contents-chapter-num col span_1_of_12 span_1_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp fsh-0 no-padding">
                <h3 class="fsh-0 learnworlds-heading3 learnworlds-heading3-large learnworlds-element no-margin-bottom">
                    {{sectionNumber}}
                </h3>
            </div>
            <div class="pr-0 col span_11_of_12 span_11_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp lw-bl-3px-fadeout80">
                <div class="with-flexible-parts justify-content-space-between align-items-center">
                    <h3 class="learnworlds-heading3 learnworlds-heading3-large learnworlds-element lw-course-contents-chapter-name no-margin-bottom">{{sectionTitle}}</h3>
                    <div v-if="displayAccessLabel && sectionAccess !== 'premium'" class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDisplayedAccessLabel}}</div>

                    <!-- drip feed -->
                    <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                        <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                        <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
                    </div>
                    <!----->

                </div>

                <div v-if="sectionDescription" class="mt-2rem learnworlds-main-text-large">{{ sectionDescription }}</div>

                <div class="lw-course-contents-units mt-2rem lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp">
                    <div class="lw-course-contents-unit col no-padding mb-2rem span_3_of_12 span_3_of_12-tl span_4_of_12-tp span_4_of_12-sl span_12_of_12-sp" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">
                        <div class="learnworlds-screen-wrapper learnworlds-element full">
                            <div class="learnworlds-frame">
                                <div class="lw-screen-content">
                                    <div class="js-learnworlds-overlay lw-dark-bg learnworlds-bg-default-overlay">
                                        <unit-icon class="lw-contents-svg normal pos-abs center" :icon="unit.icon"></unit-icon>
                                    </div>
                                    <div class="learnworlds-screen-caption bottom with-flexible-parts lw-brand-bg-fadeout60">
                                        <span class="mr-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-check"  v-if="unitCompleted(unit)"></span>
                                        <div class="mr-10px learnworlds-main-text no-margin-bottom learnworlds-main-text-small learnworlds-element">{{unit.title}}</div>
                                        <span class="no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
                                    </div>
                                    <div class="learnworlds-AR-16-9 learnworlds-bg-default" :style="getUnitBackgroundImageStyle(unit)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate8",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin]
    }
</script>

